import React from "react";
import classes from "./h2.module.scss";

const H2 = ({ iconLeft, iconRight, className = "", children, border }) => {
  let _content = children;
  const _iconLeft = iconLeft ? (
    <span className={classes.IconLeft}>{iconLeft}</span>
  ) : null;
  const _iconRight = iconRight ? (
    <span className={classes.IconRight}>{iconRight}</span>
  ) : null;
  let finalClass = className ? className : "";
  if (border) finalClass += " " + classes.BorderBottom;

  return (
    <h2 className={finalClass + " " + classes.H2}>
      {_iconLeft}
      {_content}
      {_iconRight}
    </h2>
  );
};
export default H2;
